import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ToastController, ActionSheetController, AlertController } from '@ionic/angular';
import { version } from './global.config';
import { Subscription } from 'rxjs';
import { User } from './signin/credentials';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { MapNavigationService } from './utils/map-top-toolbar/map-navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  version: string = version;
  currentUser: User | null;
  backButtonSubscription: Subscription;
  interval: any;
  showMapToolbar = false;

  private routeAllowsToolbar = false;
  private toolbarHidden = false;
  private readonly mapToolbarRoutes = ['/client', '/path', '/stop', '/mileage', '/overspeed', '/video-playback'];

  constructor(
    private toastController: ToastController,
    public actionSheetCtrl: ActionSheetController,
    public alertController: AlertController,
    private translate: TranslateService,
    private router: Router,
    private mapNavigationService: MapNavigationService,
  ) {
    this.mapNavigationService.toolbarHidden$.subscribe((hidden) => {
      this.toolbarHidden = hidden;
      this.refreshToolbar();
    });
    this.translate.addLangs(['en', 'fr', 'ar']);
    this.translate.setDefaultLang('fr');

    const savedLang = localStorage.getItem('lang');
    const browserLang = this.translate.getBrowserLang();
    const lang = (savedLang && ['en', 'fr', 'ar'].includes(savedLang))
      ? savedLang
      : (browserLang && browserLang.match(/en|fr|ar/) ? browserLang : 'fr');
    this.translate.use(lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;

    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    this.checkPreviousAuthorization();
    this.updateToolbarVisibility(this.router.url);
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e) => {
      this.updateToolbarVisibility((e as NavigationEnd).urlAfterRedirects);
    });
  }

  private updateToolbarVisibility(url: string) {
    this.routeAllowsToolbar = this.mapToolbarRoutes.some((route) => url.includes(route));
    this.refreshToolbar();
  }

  private refreshToolbar() {
    this.showMapToolbar = this.routeAllowsToolbar && !this.toolbarHidden;
  }

  // Vérification de l'authentification et affichage du toast en cas de session expirée
  async checkPreviousAuthorization() {
    if (!this.currentUser) {
      const toast = await this.toastController.create({
        message: this.translate.instant('APP.SESSION_EXPIRED'),
        duration: 4000,
        position: 'top',
        color: 'warning'
      });
      await toast.present();
    }
  }

  // Alert de confirmation pour quitter l'application
  async presentExitAlert() {
    const alert = await this.alertController.create({
      header: this.translate.instant('APP.EXIT_TITLE'),
      message: this.translate.instant('APP.EXIT_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('APP.CANCEL'),
          role: 'cancel',
          handler: () => {
            this.alertController.dismiss();
          }
        },
        {
          text: this.translate.instant('APP.QUIT'),
          handler: () => {
            navigator['app'].exitApp();
          }
        }
      ]
    });
    await alert.present();
  }
}
